var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C5.3835 2 0 7.3835 0 14C0 16.6108 0.8355 19.1007 2.4165 21.2015L2.64075 21.5H21.3585L21.5835 21.2015C23.1645 19.1007 24 16.6108 24 14C24 7.3835 18.6165 2 12 2ZM11.2501 4.24999H12.7501V6.49999H11.2501V4.24999ZM2.2501 14.75H4.5001V13.25H2.2501V14.75ZM6.16647 9.22696L4.57572 7.63622L5.63622 6.57497L7.22697 8.16572L6.16647 9.22696ZM10.7182 14.6165C11.0595 15.3717 11.9475 15.707 12.7027 15.3665C13.458 15.026 13.794 14.1372 13.4527 13.3827C13.1122 12.6275 8.99997 7.16373 8.99997 7.16373C8.99997 7.16373 10.3777 13.862 10.7182 14.6165ZM17.8337 9.22696L16.7732 8.16646L18.3639 6.57497L19.4244 7.63547L17.8337 9.22696ZM19.5 13.25V14.75H21.75V13.25H19.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.5a8c2180.svg";
export { ForwardRef as ReactComponent };